import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, CircularProgress } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';

interface DeleteClassModalProps {
  open: boolean;
  className: string;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteClassModal({ open, className, isDeleting, onClose, onConfirm }: DeleteClassModalProps) {
  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main', pb: 1 }}>
        <WarningAmber />
        Excluir Turma
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja excluir permanentemente a turma <strong>{className}</strong>?
        </DialogContentText>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Essa ação não poderá ser desfeita. Todos as estatísticas de presença e vínculos de alunos serão perdidos.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ textTransform: 'none' }}>
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained" 
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ textTransform: 'none', fontWeight: 'bold' }}
        >
          {isDeleting ? 'Excluindo...' : 'Sim, Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}